import React from "react";
import { Button, Container } from "../../Styles/Global.Styled";
import CheckmarkIcon from "../../Icons/CheckmarkIcon";
import { css } from "styled-components";

const custBttn = (disabled) => css`
  /* border: 2px solid red; */
  align-self: start;
  justify-content: flex-start;
  font-size: 1.5vh;
  gap: 0.5vh;
  /* text-decoration: ${disabled && "line-through"}; */
`;
const cntStyle = (isChecked, disabled) => css`
  border: 1px solid ${({ theme }) => theme.thirdColor};
  background-color: ${({ theme }) => (isChecked ? theme.main : null)};
  border-radius: 6px;
  height: 2vh;
  width: 2vh;
  align-items: center;
  justify-content: center;
  opacity: ${disabled && ".5"};
`;

const Checkbox = ({ value, isChecked = false, handleChange, disabled }) => {
  return (
    <Button
      $baseStyle={custBttn(disabled)}
      disabled={disabled}
      type="button"
      onClick={() => handleChange({ isChecked: !isChecked, value: value })}
    >
      <Container $baseStyle={cntStyle(isChecked, disabled)}>
        <CheckmarkIcon color="white" style={{ width: "75%", height: "75%" }} />
      </Container>
      {value}
    </Button>
  );
};

export default Checkbox;
